<section class="entrance-history-banner" aria-labelledby="entrance-history-banner-title">
  <div class="entrance-history-banner__content">
    <div class="entrance-history-banner__text">
      <h2 id="entrance-history-banner-title">
        <span class="entrance-history-banner__title-bracket">「</span>入試正解<span class="entrance-history-banner__title-bracket">」</span
        >は、<br class="sp-only" />いつの時代も受験生のそばに。
      </h2>
      <p>
        前身の『入学試験問題詳解』として<br class="sp-only" />1935年に刊行以来、<br />
        『全国大学入試問題正解』は<br class="sp-only" />日本の大学受験史と<br class="pc-only" />
        共に歩んできました。
      </p>
      <a [href]="entranceHistoryUrl" target="_blank" rel="noopener noreferrer">
        入試正解シリーズの歴史について
      </a>
    </div>
    <img
      src="/assets/images/lp/picture-since-1935@2x.png"
      alt="『入学試験問題詳解』と『全国大学入試問題正解』の書影"
      width="406"
      height="209"
      loading="lazy"
      class="entrance-history-banner__image"
    />
  </div>
</section>
